import Vue from 'vue'
import DatePicker from 'cube-ui/src/modules/date-picker'
import Picker from 'cube-ui/src/modules/picker'
import Scroll from 'cube-ui/src/modules/scroll'
import Slide from 'cube-ui/src/modules/slide'

import Tab from 'vant/lib/tab'
import Tabs from 'vant/lib/tabs'
import Cell from 'vant/lib/cell'
import CellGroup from 'vant/lib/cell-group'
import Icon from 'vant/lib/icon'
import Search from 'vant/lib/search'
import Field from 'vant/lib/field'
import List from 'vant/lib/list'
import Popup from 'vant/lib/popup'
import Overlay from 'vant/lib/overlay'
import NoticeBar from 'vant/lib/notice-bar'
import Uploader from 'vant/lib/uploader'
import Image from 'vant/lib/image'
import Radio from 'vant/lib/radio'
import RadioGroup from 'vant/lib/radio-group'
import Row from 'vant/lib/row'
import Col from 'vant/lib/col'
import Form from 'vant/lib/form'
import Button from 'vant/lib/button'
import Checkbox from 'vant/lib/checkbox'
import CheckboxGroup from 'vant/lib/checkbox-group'
import PickerVant from 'vant/lib/picker'
import Popover from 'vant/lib/popover'
import Loading from 'vant/lib/loading'

import 'vant/lib/tab/index.css'
import 'vant/lib/tabs/index.css'
import 'vant/lib/cell/index.css'
import 'vant/lib/cell-group/index.css'
import 'vant/lib/icon/index.css'
import 'vant/lib/search/index.css'
import 'vant/lib/field/index.css'
import 'vant/lib/list/index.css'
import 'vant/lib/popup/index.css'
import 'vant/lib/overlay/index.css'
import 'vant/lib/notice-bar/index.css'
import 'vant/lib/uploader/index.css'
import 'vant/lib/image/index.css'
import 'vant/lib/radio/index.css'
import 'vant/lib/radio-group/index.css'
import 'vant/lib/row/index.css'
import 'vant/lib/col/index.css'
import 'vant/lib/checkbox/index.css'
import 'vant/lib/checkbox-group/index.css'
import 'vant/lib/picker/index.css'
import 'vant/lib/popover/index.css'
import 'vant/lib/loading/index.css'

Vue.use(DatePicker)
  .use(Scroll)
  .use(Slide)
  .use(Picker)

Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Icon)
Vue.use(Search)
Vue.use(Field)
Vue.use(List)
Vue.use(Popup)
Vue.use(Overlay)
Vue.use(NoticeBar)
Vue.use(Uploader)
Vue.use(Image)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Row)
Vue.use(Col)
Vue.use(Form)
Vue.use(Button)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(PickerVant)
Vue.use(Popover)
Vue.use(Loading)
